var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "background-auth" },
    [
      _c(
        "v-toolbar",
        {
          staticClass: "mb-2 pl-9 pt-3 grey-background",
          staticStyle: {
            position: "fixed",
            "z-index": "10",
            "padding-bottom": "54px",
            "border-bottom": "1px solid var(--light-grey-50) !important",
          },
          attrs: {
            flat: "",
            height: "96",
            width: `calc(100% - ${
              _vm.$store.state.base.isExpandNavigationDrawer ? "210px" : "50px"
            })`,
          },
        },
        [
          _c(
            "v-toolbar-title",
            { staticClass: "d-block subtitle-1 font-weight-bold" },
            [_vm._v("Organizaciones")]
          ),
          _c("v-spacer"),
          _c(
            "v-toolbar-items",
            { staticClass: "pr-9" },
            [
              _c(
                "v-row",
                {
                  attrs: { align: "center", justify: "end", "no-gutters": "" },
                },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-click": "",
                        "close-on-content-click": "",
                        "offset-y": "",
                        "nudge-bottom": 8,
                        right: "",
                        transition: "slide-y-transition",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "px-0",
                                      attrs: {
                                        small: "",
                                        outlined: "",
                                        height: "35",
                                        ripple: false,
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { size: "18", color: "grey-500" },
                                    },
                                    [_vm._v("mdi-filter-plus")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "v-list",
                        { staticClass: "px-3 py-1" },
                        _vm._l(
                          _vm.countriesList.slice(0, 2),
                          function (country) {
                            return _c(
                              "v-list-item",
                              {
                                key: country.id,
                                staticClass: "pa-0",
                                attrs: {
                                  "active-class": "transparent",
                                  ripple: false,
                                },
                              },
                              [
                                _c(
                                  "v-list-item-title",
                                  {
                                    staticClass:
                                      "p-0 subtitle-2 text--grey-700 font-weight-medium",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex" },
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "ml-n1",
                                          attrs: {
                                            color: "green-500",
                                            value: country.id,
                                            dense: "",
                                            "hide-details": "",
                                            ripple: false,
                                          },
                                          model: {
                                            value: _vm.selectedCountry,
                                            callback: function ($$v) {
                                              _vm.selectedCountry = $$v
                                            },
                                            expression: "selectedCountry",
                                          },
                                        }),
                                        _c("img", {
                                          staticClass: "ml-1",
                                          attrs: {
                                            src: require(`@/assets/flags/flag-${country.id.toLowerCase()}.svg`),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "pa-0 ml-2",
                      staticStyle: {
                        "min-width": "200px !important",
                        width: "350px !important",
                      },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          autocomplete: "off",
                          outlined: "",
                          placeholder: "Buscar...",
                          "prepend-inner-icon": "mdi-magnify",
                          "single-line": "",
                          dense: "",
                          maxlength: "64",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.filterAccountText,
                          callback: function ($$v) {
                            _vm.filterAccountText = $$v
                          },
                          expression: "filterAccountText",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content px-8 mt-n5" },
        [
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass: "mt-16 pt-10",
                  style: `width: calc(100% - ${
                    _vm.$store.state.base.isExpandNavigationDrawer
                      ? "225px"
                      : "70px"
                  });`,
                },
                _vm._l(2, function (item) {
                  return _c(
                    "v-col",
                    { key: item, staticClass: "pr-3", attrs: { cols: "6" } },
                    [
                      _c("v-skeleton-loader", {
                        staticClass: "rounded-md",
                        attrs: { type: "card-heading" },
                      }),
                    ],
                    1
                  )
                }),
                1
              )
            : [
                _vm.accounts.length
                  ? _c(
                      "div",
                      {
                        staticClass: "mt-16 pa-0 pt-10 d-flex",
                        style: `width: calc(100% - ${
                          _vm.$store.state.base.isExpandNavigationDrawer
                            ? "225px"
                            : "70px"
                        });`,
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pa-0",
                            staticStyle: { flex: "1", "min-width": "300px" },
                          },
                          [
                            _vm.accounts.length
                              ? _c(
                                  "v-card",
                                  {
                                    staticClass: "pa-0 pb-16 transparent",
                                    attrs: { flat: "" },
                                  },
                                  [
                                    _c(
                                      "v-card-text",
                                      {
                                        directives: [
                                          {
                                            name: "scroll",
                                            rawName: "v-scroll:#scroll-target",
                                            value: _vm.onScroll,
                                            expression: "onScroll",
                                            arg: "#scroll-target",
                                          },
                                        ],
                                        key: _vm.reset,
                                        staticClass: "pa-0",
                                      },
                                      [
                                        _vm._l(_vm.accounts, function (d, i) {
                                          return _c(
                                            "v-col",
                                            {
                                              key: i,
                                              staticClass: "pr-8 pl-0",
                                            },
                                            [
                                              _c(
                                                "v-lazy",
                                                {
                                                  attrs: {
                                                    value: _vm.page,
                                                    options: { threshold: 0.5 },
                                                    transition:
                                                      "fade-transition",
                                                  },
                                                },
                                                [
                                                  _c("v-hover", {
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            hover,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-card",
                                                                {
                                                                  staticClass:
                                                                    "pa-0",
                                                                  attrs: {
                                                                    elevation:
                                                                      hover
                                                                        ? 6
                                                                        : 0,
                                                                    ripple: false,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.setAccount(
                                                                          d
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-card-text",
                                                                    {
                                                                      staticClass:
                                                                        "py-6 px-5",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "d-flex mb-3 align-center justify-sm-space-between",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-col",
                                                                            {
                                                                              staticClass:
                                                                                "pa-0",
                                                                              staticStyle:
                                                                                {
                                                                                  "min-width":
                                                                                    "40px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  cols: "1",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      color:
                                                                                        "green-500",
                                                                                      size: "22",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-domain"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  width: 24,
                                                                                  src: require(`@/assets/flags/flag-${d.country.toLowerCase()}.svg`),
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "v-row",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "no-gutters":
                                                                                "",
                                                                              align:
                                                                                "center",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-col",
                                                                            {
                                                                              staticClass:
                                                                                "pa-0",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "d-block text-truncate",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "max-width":
                                                                                        "80%",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "grey-700--text font-weight-medium body-1",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          d.name
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "d-block mt-1 body-2 grey-300--text",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      d.country ===
                                                                                        "CL"
                                                                                        ? "RUT"
                                                                                        : "RUC"
                                                                                    ) +
                                                                                      " " +
                                                                                      _vm._s(
                                                                                        d.tax_id
                                                                                      )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }),
                                        _vm.lazyLoading
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center mb-n12 mt-5",
                                              },
                                              [
                                                _c("v-progress-circular", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "grey-900",
                                                    width: 2,
                                                    size: 26,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "pa-0",
                            staticStyle: { flex: "1" },
                            attrs: { justify: "end" },
                          },
                          [
                            _c(
                              "v-row",
                              {
                                staticStyle: { "min-height": "80vh" },
                                attrs: { justify: "end", "no-gutters": "" },
                              },
                              [
                                _c("v-img", {
                                  staticClass: "ml-16",
                                  staticStyle: {
                                    position: "fixed",
                                    bottom: "0",
                                    right: "0",
                                  },
                                  attrs: {
                                    contain: "",
                                    src: require(`@/assets/org-light.svg`),
                                    position: "right",
                                    "aspect-ratio": 13 / 9,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _c(
                      "v-row",
                      {
                        staticStyle: { "margin-top": "140px" },
                        attrs: { aling: "center", justify: "start" },
                      },
                      [
                        !_vm.accountsCount ||
                        (_vm.filterAccountText.length > 0 &&
                          _vm.filterAccountText.length < 3)
                          ? _c(
                              "v-col",
                              [
                                _c("v-empty-state", {
                                  attrs: {
                                    title:
                                      "No existen organizaciones que coincidan con tu búsqueda.",
                                    description:
                                      "Modifica la búsqueda para obtener registros",
                                    type: "organization",
                                    customClass: "mt-6",
                                    height: 250,
                                    isFree: true,
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "v-col",
                              [
                                _c("v-empty-state", {
                                  attrs: {
                                    title:
                                      "Tu cuenta de usuario no tiene una organización asociada.",
                                    description:
                                      "Solicita una organización a soporte",
                                    type: "organization",
                                    customClass: "mt-6",
                                    height: 250,
                                    isFree: true,
                                  },
                                }),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }